'use client';

import { Heading, type HeadingProps } from '@eliadmin/core/src/components/ui/heading';

import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';

interface SectionHeadingProps {
  subtitle?: string;
  title: string;
  description?: string;
  align: 'center' | 'left';
  containerWidth?: boolean;
  innerHtml?: string;
  className?: { description?: string; title?: HeadingProps['className']; container?: string };
}

export function SectionHeading({
  subtitle,
  title,
  description,
  innerHtml,
  align,
  containerWidth = false,
  className,
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-6',
        containerWidth && 'custom-container',
        align === 'left'
          ? 'items-start justify-start text-left'
          : 'items-center justify-center text-center',
        className?.container,
      )}
    >
      <Heading
        subtitle={subtitle}
        title={title}
        center={align === 'center'}
        className={{
          container: cn(
            align === 'center'
              ? 'items-center justify-center text-center'
              : 'items-start justify-start text-left',
            className?.title?.container,
          ),
          title: className?.title?.title,
        }}
      />
      {!!description && (
        <Paragraph
          size="lg"
          className={cn(align === 'center' && 'text-center', className?.description)}
        >
          {description}
        </Paragraph>
      )}
      {!!innerHtml && (
        <Paragraph
          size="lg"
          className={cn(align === 'center' && 'text-center', className?.description)}
          innerHtml={innerHtml}
        />
      )}
    </div>
  );
}
